import store from "../..";
import {
  createNewEventService,
  deleteEventService,
  editEventService,
  fetchedLiveToken,
  joinEventService,
  listEventInviteesService,
  listEventsService,
  listEventsTypeService,
  updateEventInviteesService,
  updateEventStatusService,
} from "../../../services/event";
// import { getCommentsService } from "../../../services/timeline";
import {
  CHANGE_EVENT_STATUS,
  CREATE_NEW_EVENT,
  CREATE_SESSION_ERROR,
  CREATE_SESSION_LOADING,
  DELETE_EVENT,
  EVENT_LIVE_ERROR,
  EVENT_LIVE_LOAD,
  EVENT_LIVE_LOADING,
  EVENTS_LOADING,
  EVENTS_TYPE_LOADING,
  GET_EVENT_INVITEES,
  GET_EVENT_INVITEES_ERROR,
  GET_EVENT_INVITEES_LOADING,
  JOIN_POST_EVENT,
  LOAD_EVENTS,
  LOAD_EVENTS_ERROR,
  LOAD_EVENTS_TYPE,
  LOAD_EVENTS_TYPE_ERROR,
  NEW_EVENT_ERROR,
  NEW_EVENT_LOADING,
  SINGLE_EVENT_ERROR,
  SINGLE_EVENT_LOAD,
  SINGLE_EVENT_LOADING,
  UPDATE_EVENT_INVITEES,
} from "../types";
export const fetchTokenLiveEventACtion =
  ({ eventId, cb }) =>
  (dispatch) => {
    return fetchedLiveToken({ id: eventId }).then((res) => {
      return cb(res);
    });
  };
export const getEventsAction =
  ({ page, limit, text, type, chatId, startDate, endDate }) =>
  (dispatch) => {
    dispatch({ type: EVENTS_LOADING });

    return listEventsService({
      page,
      limit,
      text,
      type,
      status: type === "accepted" || type === "pending" ? type : undefined,
      chatId,
      startDate,
      endDate,
    })
      .catch((e) =>
        dispatch({
          type: LOAD_EVENTS_ERROR,
          payload: e,
        })
      )
      .then((d) => {
        dispatch({
          type: LOAD_EVENTS,
          payload: d,
        });
      });
  };

export const getEventAction =
  ({ page, limit, text, type, chatId, startDate, endDate, status, appId }) =>
  (dispatch) => {
    dispatch({ type: EVENTS_LOADING });

    return listEventsService({
      page,
      limit,
      text,
      type,
      status,
      chatId,
      startDate,
      endDate,
      appId,
    })
      .catch((e) =>
        dispatch({
          type: LOAD_EVENTS_ERROR,
          payload: e,
        })
      )
      .then((d) => {
        if (d?.error)
          return dispatch({
            type: LOAD_EVENTS_ERROR,
            payload: d?.error,
          });

        dispatch({
          type: LOAD_EVENTS,
          payload: d,
        });
      });
  };

export const createEventAction =
  ({ data, cb = () => {} }) =>
  (dispatch) => {
    dispatch({ type: NEW_EVENT_LOADING });
    createNewEventService({ data }).then((res) => {
      const { data, error } = res;
      if (error) {
        dispatch({ type: NEW_EVENT_ERROR, payload: error });
        cb(error);
        return;
      }
      if (cb) cb(error, data);
      dispatch({ type: CREATE_NEW_EVENT, payload: data });
    });
  };

// export const editEventAction =
//   ({ data, cb, postId }) =>
//   (dispatch) => {
//     editEventService({ sendData: data }).then(async (res) => {
//       const { data, error } = res;
//       if (error) {
//         console.error(error);
//         return;
//       }
//       if (postId) {
//         const { data: postData, error: postError } = await getCommentsService({
//           postId,
//           limit: 1,
//           page: 1,
//         });
//         if (postError) {
//           cb(postError);
//           return console.error(postError);
//         }
//         dispatch({ type: UPDATE_POST, payload: postData?.post });
//       }

//       if (cb) cb(null, data);
//     });
//   };

export const joinEventPostACtion =
  ({ postId, eventId }) =>
  (dispatch) => {
    return joinEventService({ eventId }).then((res) => {
      const { error, data } = res;
      if (error) return console.error(error);
      dispatch({ type: JOIN_POST_EVENT, payload: { postId, ...data } });
    });
  };

export const getSingleEventAction =
  ({ eventId }) =>
  (dispatch) => {
    dispatch({ type: SINGLE_EVENT_LOADING });
    return listEventsService({ eventId }).then((res) => {
      const { error, data } = res;
      if (!data) return dispatch({ type: SINGLE_EVENT_ERROR, payload: error });

      if (!data?.length) {
        return dispatch({ type: SINGLE_EVENT_ERROR, payload: "no events" });
      }
      dispatch({
        type: SINGLE_EVENT_LOAD,
        payload: data?.length ? data[0] : null,
      });
    });
  };

export const getEventInviteesAction =
  ({ page, limit, text, eventId, next }) =>
  (dispatch) => {
    if (next) {
      let { thisPage, allPages, loading } =
        store?.getState()?.events?.singleEvent?.invitees;
      if (loading) return;
      if (parseInt(thisPage) >= parseInt(allPages)) return;
      page = thisPage + 1;
    }

    dispatch({ type: GET_EVENT_INVITEES_LOADING });
    return listEventInviteesService({
      page,
      limit,
      text,
      eventId,
    })
      .catch((e) =>
        dispatch({
          type: GET_EVENT_INVITEES_ERROR,
          payload: e,
        })
      )
      .then((d) => {
        dispatch({
          type: GET_EVENT_INVITEES,
          payload: d,
        });
      });
  };
export const updateEventInviteesAction =
  ({ eventId, addingUserIds, removingUserIds, cb }) =>
  (dispatch) => {
    return updateEventInviteesService({
      eventId,
      addingUserIds,
      removingUserIds,
    }).then((res) => {
      const { data, error } = res;
      if (error) {
        cb && cb(error);
        return console.error(error);
      }
      let { addingUsers = [] } = data;
      addingUsers = addingUsers.map((user) => ({
        ...user,
      }));
      cb && cb(null, data);
      dispatch({
        type: UPDATE_EVENT_INVITEES,
        payload: {
          removingUserIds,
          addingUsers,
          eventId,
        },
      });
    });
  };

export const deleteEventACtion =
  ({ eventId }) =>
  (dispatch) => {
    deleteEventService({ eventIds: [eventId] }).then((res) => {
      dispatch({ type: DELETE_EVENT, payload: eventId });
    });
  };
export const changeEventStatus =
  ({ eventId, status, cb }) =>
  (dispatch) => {
    return updateEventStatusService({ eventId, status }).then((res) => {
      const { error, data } = res;
      cb && cb();
      if (error) {
        return console.error(error);
      }
      const { status: tStatus = {} } = data;
      dispatch({
        type: CHANGE_EVENT_STATUS,
        payload: { eventId, ...tStatus },
      });
    });
  };

export const getEventTypeAction =
  ({ page, limit, pageId }) =>
  (dispatch) => {
    dispatch({ type: EVENTS_TYPE_LOADING });

    return listEventsTypeService({
      page,
      limit,
      pageId,
    })
      .catch((e) =>
        dispatch({
          type: LOAD_EVENTS_TYPE_ERROR,
          payload: e,
        })
      )
      .then((d) => {
        dispatch({
          type: LOAD_EVENTS_TYPE,
          payload: d,
        });
      });
  };

export const getLiveTokenAction =
  ({ eventId }) =>
  (dispatch) => {
    dispatch({ type: EVENT_LIVE_LOADING });
    return fetchedLiveToken({ id: eventId }).then((res) => {
      const { error, data } = res;
      if (!data) return dispatch({ type: EVENT_LIVE_ERROR, payload: error });

      if (!data) {
        return dispatch({
          type: EVENT_LIVE_ERROR,
          payload: "connection failed",
        });
      }
      dispatch({
        type: EVENT_LIVE_LOAD,
        payload: data,
      });
    });
  };

export const createSessionAction =
  ({ data, cb = () => {}, fetchStages }) =>
  (dispatch) => {
    dispatch({ type: CREATE_SESSION_LOADING });
    createNewEventService({ data }).then((res) => {
      const { data, error } = res;
      if (error) {
        dispatch({ type: CREATE_SESSION_ERROR, payload: error });
        cb(error);
        return;
      }
      if (cb) cb(error, data);
      fetchStages({ page: 1 });
    });
  };

export const editSessionAction =
  ({ data, cb, fetchStages }) =>
  (dispatch) => {
    dispatch({ type: CREATE_SESSION_LOADING });
    editEventService({ sendData: data }).then(async (res) => {
      const { data, error } = res;
      if (error) {
        if (cb) cb(error);
        return console.error(error);
      }
      fetchStages({ page: 1 });
      if (cb) cb(null, data);
    });
  };
